<template>
  <base-layout>
    <div class="auth-container">
      <div class="guest-page-form" v-show="!isshow">
        <div class="form-container">
          <div class="guest-page-form-header text-center">
            <span class="title-l"></span>
            <h3 class="title-account">OTP Verification</h3>
            <span class="title-l"></span>
          </div>
          <div class="guest-page-form-body pt-20">
            <div class="input-group input-group-otp">
              <div class="text-description">
                Enter the OTP code sent to your email
              </div>
            </div>
            <div class="otp-container">
              <v-otp-input
                ref="otpInput"
                input-classes="otp-input"
                separator=""
                :num-inputs="6"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-change="handleOnChange"
                @on-complete="handleOnComplete"
                :disabled="isSubmitting"
              />
            </div>
            <div class="form_actions">
              <button
                :class="{ chrome_only: isChrome }"
                tabindex="0"
                :disabled="isSubmitting"
                type="button"
                class="btn-primary"
                @click="sendResetPasswordEmail"
              >
                {{ getSubmitName($t("reset_password.submit_btn_2")) }}
              </button>
            </div>
            <div
              class="resend-otp-section d-flex justify-content-center align-items-center"
            >
              <button
                type="button"
                class="btn-resend-otp"
                :disabled="countdown > 0 || isSubmitting"
                @click="resendOtp"
              >
                <span v-if="countdown > 0" class="resend-text">
                  Resend OTP
                  <span class="countdown-timer">{{ formattedCountdown }}</span>
                </span>
                <span v-else> Resend OTP </span>
              </button>
            </div>
            <div class="back-login d-fex justify-content-center">
              <span>
                {{ $t("reset_password.back_to") }}
                <router-link class="btn-back-login" to="/login">{{
                  $t("login.title")
                }}</router-link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
import BaseLayout from "./BaseLayout.vue";
import { mapState } from "vuex";
import rf from "@/request/RequestFactory";
import AuthenticationUtils from "@/common/AuthenticationUtils";
import CookiesUtils from "@/common/CookiesUtils";
import COMMON_CONST from "@/common/Const";
import Cookies from "js-cookie";

export default {
  components: {
    BaseLayout,
  },
  data() {
    return {
      otp: "",
      email: "",
      password: "",
      geetestData: "",
      isshow: false,
      isChrome: window.navigator.userAgent.toLowerCase().indexOf("chrome") > 0,
      countdown: 0,
      countdownTimer: null,
    };
  },
  computed: {
    ...mapState({
      userThemeMode: (state) => state.userThemeMode,
    }),
    formattedCountdown() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
        2,
        "0"
      )}`;
    },
  },
  methods: {
    handleOnComplete(value) {
      console.log("OTP completed: ", value);
      this.otp = value;
      // Auto submit when OTP is complete
      if (value.length === 6) {
        this.sendResetPasswordEmail();
      }
    },
    handleOnChange(value) {
      console.log("OTP changed: ", value);
      this.otp = value;
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
    },
    startCountdown() {
      this.countdown = 30;
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    async resendOtp() {
      if (this.countdown > 0 || this.isSubmitting) {
        return;
      }

      this.startSubmit();

      try {
        // Get current locale
        const lang =
          Cookies.get("locale", {
            domain: process.env.VUE_APP_PUBLIC_URL,
          }) || "en";

        // Call resend OTP API
        await rf.getRequest("UserRequest").resendOtpCode(lang);

        this.endSubmit();
        this.$toasted.success(this.$t("funds.withdrawals.otp_code_sent"));

        // Start countdown after successfully sending OTP
        this.startCountdown();

        // Clear current OTP input
        this.handleClearInput();
      } catch (error) {
        this.endSubmit();
        if (error.response && error.response.data) {
          this.$toasted.error(this.$t(`${error.response.data.message}`));
        } else {
          this.$toasted.error(this.$t("common.error.something_went_wrong"));
        }
      }
    },
    async sendResetPasswordEmail() {
      if (this.otp.length !== 6) {
        this.$toasted.error(
          this.$t("funds.withdrawals.errors.otp_length_6_digits")
        );
        return;
      }

      if (this.isSubmitting) {
        return;
      }

      this.startSubmit();

      try {
        // Get current locale
        const lang =
          Cookies.get("locale", {
            domain: process.env.VUE_APP_PUBLIC_URL,
          }) || "en";

        // Call verify OTP API
        const response = await rf
          .getRequest("UserRequest")
          .verifyOtpCode(this.otp, lang);

        this.endSubmit();

        // Remove old checkTerminal data
        localStorage.removeItem("checkTerminal");

        // Save new authentication data with new access_token
        // Note: response is already unwrapped by BaseRequest._responseHandler
        localStorage.setItem("checkTerminal", JSON.stringify(response));
        console.log("OTP Verification Success:", response);

        let locale = response.locale;
        response.locale =
          Cookies.get("locale", {
            domain: process.env.VUE_APP_PUBLIC_URL,
          }) || locale;

        AuthenticationUtils.saveAuthenticationData(response);

        // Redirect to home or destination
        const defaultRouteName = "Landing Exchange";
        const destinationRouteName = this.$route.query.destination;
        let urlSearch = new URLSearchParams(window.location.search);
        const returnTo = urlSearch.get("return_to");
        const redirectRouteName =
          response.redirectUrl || destinationRouteName || "Landing Exchange";

        if (response?.isFirstLogin) {
          this.$toasted.success(this.$t("login.confirm_success"));
          setTimeout(() => {
            window.location.href = this.$router.resolve({
              name: defaultRouteName,
            }).href;
          }, 1500);
          return;
        }

        let targetUrl = "";
        if (returnTo == "zendesk") {
          targetUrl = redirectRouteName;
        } else {
          targetUrl = this.$router.resolve({
            name: redirectRouteName,
          }).href;
        }

        if (targetUrl == "/") {
          targetUrl = this.$router.resolve({
            name: defaultRouteName,
          }).href;
        }

        // Check for Japanese locale agreement
        let acceptAgreement = !!CookiesUtils.getItem(
          COMMON_CONST.LOGIN_ACCEPT_AGREEMENT
        );

        window.localStorage.removeItem("Trade_popup");

        if (window.localStorage.locale === "ja" && !acceptAgreement) {
          // Show agreement popup for Japanese users
          // You may need to implement this similar to Login.vue
          window.location.href = targetUrl;
        } else {
          window.location.href = targetUrl;
        }
      } catch (error) {
        this.endSubmit();
        if (error.response && error.response.data) {
          this.$toasted.error(this.$t(`${error.response.data.message}`));
          // Clear OTP input on error
          this.handleClearInput();
        } else {
          this.$toasted.error(this.$t("common.error.something_went_wrong"));
        }
      }
    },
  },
  mounted() {
    // Get login credentials from sessionStorage
    this.email = sessionStorage.getItem("login_email");
    this.password = sessionStorage.getItem("login_password");
    this.geetestData = sessionStorage.getItem("login_geetest");

    // Redirect back to login if no credentials found
    // if (!this.email || !this.password) {
    //   this.$router.push("/login");
    // }
  },
  beforeDestroy() {
    // Clear countdown timer when component is destroyed
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/common.scss";
.form-input {
  display: block;
  height: 49px;
  width: 100% !important;
  max-width: 100%;
  padding: 14px 15px;
  background: var(--background-color-second);
  border-radius: 8px;
  color: var(--text-primary-color) !important;
  border: none;
  font-size: $font-big;
  &:focus,
  &:active {
    border: 1px solid $color-aquamarine !important;
  }
  &.error {
    border: 1px solid $text-color-red !important;
  }
}
.invalid-feedback {
  margin-top: 8px;
}
.pt-20 {
  padding-top: 10px;
}
.verify-box {
  border-radius: 3px;
  height: 50px;
  text-align: center;
  border: 1px solid $color-green;
  padding-left: 0 !important;
  background-color: $color-dark-blue;
  line-height: 30px;
  .icon-home2 {
    padding-right: 10px;
  }
  a {
    position: relative;
    top: 9%;
    transform: perspective(1px) translateY(-50%);
  }
}
.title {
  text-transform: uppercase;
}
.btn-primary {
  height: 50px;
  width: 100%;
  border-radius: 8px;
  background-color: $color-caribbean-green;
  text-align: center;
  color: $color-grey-dark;
  text-transform: none;
  font-family: $font-inter-regular;
  font-weight: normal;
  font-size: $font-big;
  margin: 15px 0 10px;
  &:disabled {
    background-color: $background-bright-gray !important;
    border-color: $border-bright-gray !important;
    color: $text-default !important;
  }
  &:hover:enabled,
  &:focus {
    background-color: $color-aquamarine !important;
    border-color: $border-blue-custom !important;
    color: $color-grey-dark !important;
  }
}

.resend-otp-section {
  margin: 10px 0;
}

.btn-resend-otp {
  background: transparent;
  border: none;
  color: $color-caribbean-green;
  font-family: $font-inter-regular;
  font-size: $font-big;
  cursor: pointer;
  padding: 8px 16px;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    color: $color-aquamarine;
    text-decoration: underline;
  }

  &:disabled {
    color: $color-gray-dark;
    cursor: not-allowed;
    opacity: 0.6;
  }

  .countdown-timer {
    display: inline-block;
    min-width: 45px;
    padding: 2px 8px;
    margin-left: 8px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.1);
    font-family: $font-inter-medium;
    font-weight: 500;
  }
}

.back-login {
  & span {
    font-family: $font-inter-regular;
    color: $color-gray-dark;
    font-size: $font-big;
  }
  & a {
    font-family: $font-inter-bold;
    color: $color-caribbean-green;
    font-size: $font-big;
  }
}

.title-account {
  font-size: $font-title-size-medium-2;
  line-height: 41px;
  color: var(--text-primary-color) !important;
  font-family: $font-inter-bold;
}

.text-description {
  font-family: $font-inter-regular;
  font-size: $font-big;
  line-height: 22px;
  color: var(--text-primary-color) !important;
  text-align: center;
  margin-top: 0px;
}

.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;

  :deep(.otp-input) {
    width: 68px !important;
    height: 68px !important;
    padding: 5px !important;
    margin: 0 8px !important;
    font-size: 32px !important;
    font-weight: 500 !important;
    border-radius: 16px !important;
    border: 2px solid rgba(255, 255, 255, 0.2) !important;
    background-color: rgba(40, 40, 40, 0.8) !important;
    color: var(--text-primary-color) !important;
    text-align: center !important;
    transition: all 0.3s ease !important;

    &:focus {
      outline: none !important;
      border-color: $color-caribbean-green !important;
      background-color: rgba(50, 50, 50, 0.9) !important;
    }

    &.error {
      border: 2px solid red !important;
    }

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

.title-l {
  margin: 13px 0px 15px 0px;
  height: 1px;
  //width: 30%;
  border-radius: 5px;
  background-color: $color-light-grey;
}
.email-reset {
  font-family: $font-family-roboto;
  font-size: $font-root;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.07;
  letter-spacing: normal;
  color: $text-default;
  font-weight: normal;
  &:focus,
  &:active {
    color: $text-default;
    border-bottom: 1px solid $border-alto !important;
  }
}
.text-homepage-login {
  text-decoration: none;
  background-color: $color-dark-blue;
  border: 1px solid $color-green;
  display: flex;
  /* text-align: center; */
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  height: 50px;
  // margin: 20px;
  .link-text-login {
    font-size: $font-medium;
    line-height: 40px;
    color: $color-jungle-green;
    font-weight: 500;
    align-items: center;
    justify-content: center;
    font-family: $font-family-roboto-medium;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;
  }
  .icon-network {
    color: $color-jungle-green;
    font-size: 24px;
    font-weight: normal;
    align-items: center;
    justify-content: center;
    padding: 10px;
  }
}
.input-group {
  margin-bottom: 24px;
  .icon-last {
    img {
      position: absolute;
      top: 40%;
      right: 15px;
      float: left;
      cursor: pointer;
    }
  }
  .tooltip_info {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(calc(100% + 11px));
    padding: 10px;
    background: var(--background-desc);
    border-radius: 8px;
    margin-right: -5px;
    .item {
      display: flex;
      align-items: center;
      gap: 12px;
      & + .item {
        margin-top: 8px;
      }
      i::before {
        color: $color-aqua-green;
      }
      .icon-close::before {
        color: $text-color-red;
      }
      .text {
        font-family: $font-inter-regular;
        color: $color-white;
        font-size: 18px;
        line-height: 21px;
      }
    }
  }

  .form-new-password:focus {
    ~ .tooltip_info {
      display: block;
    }
  }
}
label {
  justify-content: center;
  font-weight: 400 !important;
  font-size: $font-big;
  line-height: 22px;
  color: var(--text-primary-color) !important;
  padding: 0;
  margin-bottom: 8px;
}
.form-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 100%;
}
#confirmationModal {
  :deep(.dialog22) {
    margin: 0 !important;
  }
}
@media screen and (max-width: 992px) {
  .tooltip_info {
    top: 110% !important;
    right: 104% !important;
    width: 100%;
    z-index: 10;
  }
  #confirmationModal {
    :deep(.modal-dialog) {
      .modal-content {
        .modal-body {
          .fo_green_4,
          .fo_green_3,
          .fo_green2 {
            .tit_modal_confir {
              font-size: $font-title-size-medium-2;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .title-account {
    margin-bottom: 25px !important;
    font-size: $font-big-24;
    line-height: 29px;
  }

  label {
    font-size: $font-root !important;
    line-height: 22px;
  }

  .otp-container {
    margin: 20px 0;

    :deep(.otp-input) {
      width: 48px !important;
      height: 48px !important;
      margin: 0 4px !important;
      font-size: 24px !important;
      border-radius: 12px !important;
    }
  }

  .guest-page-form-body {
    max-width: 100%;
    .input-group {
      margin-bottom: 16px;
      width: 100%;
      input {
        font-size: $font-root !important;
      }
    }
    input {
      &:focus,
      &:active {
        border: 1px solid $color-aquamarine !important;
      }
      &.error {
        border: 1px solid $text-color-red !important;
      }
    }
    .btn-resend-otp {
      font-size: $font-root;

      .countdown-timer {
        min-width: 40px;
        padding: 2px 6px;
        margin-left: 6px;
        font-size: $font-root;
      }
    }
    .back-login {
      & span {
        font-size: $font-root;
        a {
          font-size: $font-root;
        }
      }
    }
    .btn-primary {
      width: 100%;
    }
    .form_actions {
      margin-bottom: 10px;
    }
  }

  #confirmationModal {
    :deep(.modal-dialog) {
      width: 343px !important;
      .modal-header {
        padding-top: 10px !important;
      }
      .modal-content {
        width: 343px !important;
        min-height: 281px;
        .modal-body {
          padding: 0px;
          .fo_green_4,
          .fo_green_3,
          .fo_green2 {
            img {
              width: 74px;
              height: 74px !important;
            }
            .title-header-modal {
              margin-top: 23px !important;
              font-size: $font-big-20;
              margin-bottom: 5px;
            }
            .tit_modal_confirm {
              font-size: $font-big-20;
              margin: 0;
            }
            .tit_modal_confir {
              font-size: $font-big-20;
              margin: 0;
            }
            .modal-content-text {
              font-size: $font-root;
              margin: 0 auto 10px;
            }

            .mb-20 {
              margin-bottom: 0px !important;
            }
            .mt-40 {
              margin-top: 20px !important;
            }
            .btn-resetMail {
              width: 160px !important;
              margin-top: 20px !important;
            }
            .desc-change {
              font-size: $font-root;
            }
          }
        }
      }
    }
    :deep(.dialog22) {
      //top: 40%;
      //left: 40%;
      .modal-content {
        height: 318px !important;
      }
      .btn-resetMail {
        margin-top: 15px !important;
        width: 160px !important;
        height: 50px;
      }
      .modal-content-text {
        font-size: $font-root;
        margin: 0 !important;
      }
      .mb-8 {
        margin-bottom: 5px !important;
      }
    }
  }
}

@media screen and (max-width: 375px) {
}
</style>
